import { render, staticRenderFns } from "./MocktestsSegments.vue?vue&type=template&id=117f9992&"
import script from "./MocktestsSegments.vue?vue&type=script&lang=js&"
export * from "./MocktestsSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports